import { createStyles } from '@material-ui/core';
import { toCssValue } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    title: {
        flex: 1,
        fontSize: 22,
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    appBar: {
        height: theme.layout.header.topBar,
        position: 'relative',
        color: theme.components.header.colors.text,
        backgroundColor: theme.components.header.colors.background,
        zIndex: 1200,
    },
    appToolBar: {
        minHeight: theme.layout.header.topBar,
    },
    menuIcon: {
        width: 34,
        height: 34,
        paddingBottom: 2,
        color: theme.components.header.colors.menuIcon,
    },
    buttonContainer: {
        width: 60,
        marginBottom: 3,
        textAlign: 'center',
        cursor: 'pointer',
    },
    icon: {
        width: 24,
        height: 24,
    },
    label: {
        height: 20,
        fontSize: theme.font.size.small,
        color: theme.color.font.light,
        marginTop: -2,
    },
    logo: {
        marginLeft: 5,
        paddingRight: 8,
        paddingLeft: 8,
        height: 32,
    },
    badge: {
        marginLeft: -20,
        padding: toCssValue([20, 0])
    }
});
export default styles;
//# sourceMappingURL=HeaderStyles.js.map